import React from 'react'
import * as R from 'ramda'
import PropTypes from 'prop-types'
import { Typography } from '@material-ui/core'
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined'

const EventLocation = (props) => {
  const { data } = props

  return (
    <>
      {R.isNil(data) ? null : (
        <Typography className="text-grey-300 text-12 break-all flex items-center">
          <LocationOnOutlinedIcon
            className="mr-3 text-grey-200"
            fontSize="small"
          />
          {data}
        </Typography>
      )}
    </>
  )
}

EventLocation.propTypes = {
  data: PropTypes.string,
}

export default EventLocation
